import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { route } from '../../config/constants';
import { isLoggedOut } from '../../helpers/accountHelper';
import {
  parseConsentParams,
  hasRequiredConsentParams,
  getScopeLabelKey,
} from '../../helpers/oauthConsentHelper';
import { oauthAllow, oauthDeny } from '../../store/actions/oauth';
import './styles.css';

class OAuthConsent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      error: false,
    };
  }

  handleAllow = () => {
    this.submit(oauthAllow);
  };

  handleDeny = () => {
    this.submit(oauthDeny);
  };

  submit = (action) => {
    if (this.state.submitting) {
      return;
    }
    const params = parseConsentParams(this.props.location.search);
    const self = this;
    this.setState({ submitting: true, error: false });
    action(params.requestId)
      .then(function (redirectTo) {
        if (redirectTo) {
          window.location.assign(redirectTo);
        } else {
          self.setState({ submitting: false, error: true });
        }
      })
      .catch(function () {
        self.setState({ submitting: false, error: true });
      });
  };

  render() {
    const { t, currentUser, location } = this.props;
    const params = parseConsentParams(location.search);

    // 1. Missing required params: invalid entry, go to dashboard home.
    if (!hasRequiredConsentParams(params)) {
      return <Redirect to={route.ROOT} />;
    }

    // 2. Not signed in: send through login, preserving all original params.
    if (isLoggedOut(currentUser)) {
      const returnTo = encodeURIComponent(route.OAUTH_CONSENT + location.search);
      return <Redirect to={route.START + '?returnTo=' + returnTo} />;
    }

    // 3. Consent card.
    const scopeKey = getScopeLabelKey(params.scope);
    const scopeLabel = scopeKey ? t(scopeKey) : params.scope;
    const email =
      currentUser && currentUser.contactInfo ? currentUser.contactInfo.email : '';
    const { submitting, error } = this.state;

    return (
      <div className="login-start oauth-consent">
        <div className="login-start-logo" />

        <div className="login-start-card oauth-consent-card">
          <div className="oauth-consent-badge">
            <span className="material-symbols-outlined">extension</span>
          </div>

          <h1 className="login-start-title oauth-consent-title">{t('oauth:title')}</h1>

          <p className="oauth-consent-body">
            <strong>{params.clientName}</strong> {t('oauth:requestingAccess')}
          </p>

          <div className="oauth-consent-permission">
            <span className="material-symbols-outlined oauth-consent-permission-icon">
              verified_user
            </span>
            <div className="oauth-consent-permission-text">
              <span className="oauth-consent-permission-label">
                {t('oauth:scopeLabel')}
              </span>
              <span className="oauth-consent-permission-value">{scopeLabel}</span>
            </div>
          </div>

          <div className="oauth-consent-actions">
            <button
              type="button"
              className="login-start-btn login-start-btn--secondary"
              onClick={this.handleDeny}
              disabled={submitting}
            >
              {t('oauth:deny')}
            </button>
            <button
              type="button"
              className="login-start-btn login-start-btn--primary"
              onClick={this.handleAllow}
              disabled={submitting}
            >
              {submitting ? t('oauth:working') : t('oauth:allow')}
            </button>
          </div>

          {error && (
            <div className="auth-form-error oauth-consent-error">
              {t('oauth:expiredError')}
            </div>
          )}

          <div className="oauth-consent-identity">
            <span className="material-symbols-outlined oauth-consent-identity-icon">
              account_circle
            </span>
            <span>
              {t('oauth:signedInAs')} <strong>{email}</strong>
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default OAuthConsent;
